<nav aria-label="breadcrumb" class="breadcrumb-container">
    <div class="breadcrumb">
        <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
            <ng-container *ngIf="!last">
                <a [routerLink]="breadcrumb.url" class="breadcrumb-link" mat-button>
                    {{ breadcrumb.label }}
                </a>
                <span class="breadcrumb-separator"> <mat-icon>chevron_right</mat-icon></span>
            </ng-container>
            <ng-container *ngIf="last">
                <span class="breadcrumb-current">{{ breadcrumb.label }}</span>
            </ng-container>
        </ng-container>
    </div>
</nav>
